<template>
<div>
    <div class="row footerBar">
        <div class="container">
            <h3>中国国际投资贸易洽谈会</h3>
            <div class="row page-foot-main">
                <h4>主办单位</h4>
                <div class="col-xs-12 col-sm-12 col-md-12 noPadding">中华人民共和国商务部</div>
            </div>
            <div class="row page-foot-main">
                <h4>联合主办</h4>
                <div class="col-xs-12 col-sm-4 col-md-4 noPadding">联合国贸发会议（UNCTAD）</div>
                <div class="col-xs-12 col-sm-4 col-md-4 noPadding">联合国工发组织（UNIDO）</div>
                <div class="col-xs-12 col-sm-4 col-md-4 noPadding">世界贸易组织（WTO）</div>
                <div class="col-xs-12 col-sm-4 col-md-4 noPadding">经济合作与发展组织（OECD）</div>
                <div class="col-xs-12 col-sm-4 col-md-4 noPadding">世界银行国际金融公司（IFC）</div>
                <div class="col-xs-12 col-sm-4 col-md-4 noPadding">世界投资促进机构协会（WAIPA）</div>
                <!-- <div class="col-xs-12 col-sm-4 col-md-4 noPadding">中国国际投资促进会（CCIIP）</div> -->
            </div>
            <div class="row page-foot-main">
                <h4>协办单位</h4>
                <div class="col-xs-12 col-sm-12 col-md-12 noPadding">中国国际投资促进会（CCIIP）</div>
            </div>
        </div>
        <p style="border-top:1px solid #a6a6a6;margin-top: 20px;padding-top:10px;">中国国际投资贸易洽谈会组织委员会 中国 （厦门）国际投资促进中心 版权所有</p>
        <p>技术支持：厦门纵横集团科技股份有限公司 1996-2018 <a class="to-integrated" style="color:#a6a6a6;" href="https://beian.miit.gov.cn/#/Integrated/index">闽ICP备09033537号</a>
        <a href="https://www.cnzz.com/stat/website.php?web_id=1279951123" target="_blank" title="站长统计"><img border="0" hspace="0" vspace="0" src="http://icon.cnzz.com/img/pic1.gif"></a>
        </p>
    </div>
</div>
</template>

<script>
export default {
    data () {
        return {
        }
    },
    mounted(){
        // var _gaq = _gaq || [];
        // _gaq.push(['_setAccount', 'UA-21029485-1']);
        // _gaq.push(['_trackPageview']);

        // (function() {
        //     var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
        //     ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
        //     var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
        // })();
        this.initCNZZ();
    },
    methods: {
        initCNZZ() {
            //添加脚本
            var script1 = document.createElement('script');
            script1.src = 'http://s75.cnzz.com/stat.php?id=1279951123&amp;web_id=1279951123&amp;show=pic1';
            script1.language = 'JavaScript';
            // script1.id='cnzz';
            document.body.appendChild(script1);
            
            var script2 = document.createElement('script');
            script2.src = 'http://c.cnzz.com/core.php?web_id=1279951123&amp;show=pic1&amp;t=z';
            script2.language = 'JavaScript';
            // script2.id='cnzz';
            document.body.appendChild(script2);
        }
    },
    watch: {
        '$route' () {
            if (window._czc) {
                //监听路由变化
                let location = window.location;
                let contentUrl = location.pathname + location.hash;
                let refererUrl = '/';
                window._czc.push(['_trackPageview', contentUrl, refererUrl])
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../static/function.less';
.footerBar{
    padding: 30px 0px 10px 0px;
    background: #1f1f1f;
    color: #a6a6a6;
    text-align: center;
    h3{
        font-size: 22px;
        color: #f0f0f0;
    }
    .page-foot-main{
        font-size: @font14;
        width: 55%;
        margin: 20px auto 0;
        h4{
            font-weight: bold;
            color: #f0f0f0;
            margin-bottom: 10px;
        }
        .noPadding{
            padding: 5px 0px 0px 0px;
        }
    }
    p{
        font-size: @font14;
        line-height: 26px;
    }
}
@media (min-width: 320px) and (max-width: 767px){
    .footerBar{
        text-align: left;
        padding: 20px;
        .page-foot-main{
            width: 100%;
        }
    }
}
.to-integrated:hover{
    color: #ea0e1e !important;
    text-decoration: underline;
}
</style>





// WEBPACK FOOTER //
// src/components/FooterBar/FooterBar.vue